import Vue from 'vue';

const promoRepository = {
    get: (id) => Vue.$axios.get(`promos/${id}`)
        .then(({data}) => data),

    list: () => Vue.$axios.get('promos')
        .then(({data}) => data),

    upOrder: (promoId) => Vue.$axios.post('promos/up-order', {promoId})
        .then(({data}) => data),

    downOrder: (promoId) => Vue.$axios.post('promos/down-order', {promoId})
        .then(({data}) => data),

    delete: (promoId) => Vue.$axios.post('promos/delete', {promoId})
        .then(({data}) => data, (error) => console.log(error)),

    edit: (promoId, title, description, image, actionId, info, isActive) => {
        let data = new FormData();

        data.append('promoId', promoId);

        if (title)
            data.append('description', title);

        if (description)
            data.append('description', description);

        if (info)
            data.append('info', info);

        if (actionId)
            data.append('actionId', actionId);

        if (isActive)
            data.append('isActive', isActive);

        if (image)
            data.append('image', image);

        return Vue.$axios.post('promos/edit', data)
            .then((data) => data)
    },

    create: (title, description, image, actionId, info, isActive) => {
        let data = new FormData();

        if (title)
            data.append('title', title);
        if (description)
            data.append('description', description);
        if (image)
            data.append('image', image);
        if (info)
            data.append('info', info);
        if (actionId)
            data.append('actionId', actionId);
        if (isActive)
            data.append('isActive', isActive);

        return Vue.$axios.post('promos/create', data)
            .then((data) => data)
    },
};

export default promoRepository;
